import axios from 'axios';

export const moduleOptionTaskApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/module-option-task`,
    headers: {
        'Content-Type': 'application/json'
    }
})